import React, { useEffect, useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from "@mui/material";
import { API, graphqlOperation } from "aws-amplify";
import { LoadingButton } from "@mui/lab";
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";
import { deleteAccountMaster } from "../../graphql";
import { dashboardApi } from "../../redux/apis/dashboardApi";
import { useDispatch } from "react-redux";
import { listAccountMasterv2Api } from "../../redux/apis/accountMaster.api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const DeleteSelectedParty = ({
  open,
  setOpen,
  partysData,
  rows,
  setRows,
  setSelected,
  selected,
  getPartyMasters,
  setSummaryData,
  onDelete = () => { }
}) => {
  const [loading, setloading] = useState(false);
  const [finishedArr, setFinishedArr] = useState([]);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      setloading(false);
    }
  };

  const dispatch = useDispatch()

  async function deleteGoodsItemDet(data, partyid) {
    console.log(data, "data");

    try {
      setFinishedArr([]);
      const res = await API.graphql(
        graphqlOperation(deleteAccountMaster, { accountsid: data })
      );
      let status = true
      if (res.data.deleteAccountMaster.statuscode === 'Error') {
        status = false
      }
      setFinishedArr((prev) => [...prev, { status: status, accountsid: data, partyid }])
      console.log(res);
    } catch (error) {
      setloading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    if (partysData?.length > 0) {
      if (finishedArr.length == partysData?.length) {
        // let tempPartyData = [...partysData]

        let arr = rows.filter((item, ind) => {
          if (
            partysData.includes(item?.partyid) &&
            partysData.includes(item?.partyid) &&
            finishedArr.find(
              (e) => e.status === true && e.accountsid === item?.accountsid
            ) !== undefined
          ) {
            console.log(item);
          } else {
            return item;
          }
        });
        console.log(arr, partysData, rows, finishedArr);
        let deleted = finishedArr.filter((elem) => elem.status);
        let notdeleted = finishedArr.filter((elem) => !elem.status);
        dispatch(dashboardApi.util.invalidateTags(["dashboard"]))
        dispatch(listAccountMasterv2Api.util.invalidateTags(["listAccountMaster"]))
        if (deleted.length) {
          getPartyMasters(false, rows.length - 1, deleted.length);
        }
        setRows(arr);
        handleClose(false);
        console.log(selected)

        let isCustomer = rows[0].partytypecd === "CUSTOMER" ? "Customer" : "Supplier";
        setSelected(notdeleted.map((elem) => elem.partyid).filter((elem) => elem != undefined));
        if (deleted.length == 1 && !notdeleted.length) {
          showSuccessSnackbar(`${isCustomer} Deleted`);
          onDelete()
        } else if (deleted.length > 1 && !notdeleted.length) {
          showSuccessSnackbar(`${isCustomer}s Deleted`);
          onDelete()
        } else if (notdeleted.length == 1 && deleted.length == 0) {
          showWarningSnackbar(
            `${isCustomer} cannot be deleted as account or invoice details have already been created for the ${isCustomer}`
          );
          onDelete()
        } else {
          setSummaryData({
            open: true,
            description: `${isCustomer}s cannot be deleted as account or invoice details have already been created for these ${isCustomer}s !`,
            lists: [
              ...notdeleted.map((elem) => {
                let party = rows.find((el) => el.accountsid == elem.accountsid);
                return party.partylegalname;
              }),
            ],
            title: `Some ${isCustomer}s cannot be deleted !`,
          });
          // showWarningSnackbar("Some of the Purchase cannot be deleted. Please unlink the linked payments before deletion ")
          onDelete()
        }
      }
    }
  }, [finishedArr]);

  const deleteItem = () => {
    setloading(true);
    if (partysData?.length > 0) {
      partysData.map((item) => {
        let details = rows.find((elem) => elem.partyid === item);
        deleteGoodsItemDet(details?.accountsid, item);
      });
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            backgroundColor: "white",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography sx={{ color: "rgb(60 60 60)", fontWeight: "bold" }}>
            Do you want to delete this item?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // flexDirection: { xs: 'column', sm: 'row' },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          {/* <Button onClick={handleClose} variant='outlined' sx={{flex:1,margin:'5px', fontSize : "12px"}} >No</Button> */}
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}

          <Button
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteSelectedParty;
